import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, OnChanges, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { RequestService, LayoutUtilsService, LoaderService } from '../../../shared/services';
import { FormControl, FormGroupDirective, NgForm, FormGroup } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { TranslateService } from '@ngx-translate/core';
import { MatAutocompleteSelectedEvent, MatAutocomplete } from '@angular/material/autocomplete';
import { BehaviorSubject } from 'rxjs';
import { environment } from '../../../../environments/environment';

export class My3ErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-custom-multiple-select',
  templateUrl: './custom-multiple-select.component.html',
  styleUrls: ['./custom-multiple-select.component.scss']
  ,
  standalone: false
})
export class CustomMultipleSelectComponent implements OnInit {
  public errorMessage: string = '';
  public loading: boolean = false;
  selectData: Array<any> = [];
  /* pagination Info */
  pageSize = 1500;
  pageNumber = 1;
  orderDir = 'asc';
  orderBy = 'name';
  searchText = '';

  myControl = new FormControl();
  filteredData: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);

  public hideBecauseOne: boolean = false;
  private _parentFormSubmitted = false;
  @Input() clearable: boolean = false;
  @Input() required: boolean = false;
  @Input() subDataType: string;
  public esMatcher = new My3ErrorStateMatcher();
  @Input() displayName: string[] = ['name', 'text'];
  @Input() filters: any;
  @Input() hideIfOne: boolean = false;
  @Input() itemName: string = '';
  @Input() placeholder: string = '';
  @Input() RelativeTo: string = '';
  @Input() dataType: string;
  @Input() canCash: boolean = false;
  @Input() apiTarget: string = 'list';
  @Input() conditionalDisable: boolean = false;
  public _value: any[];
  @Input()
  set value(value: any[]) {
    this._value = [];
    let valArray = [];
    for (let val of value) {
      valArray.push(val._id);
    }
    this._value = valArray;
  }
  get value(): any[] {
    return this._value;
  }
  @Input()
  set parentFormSubmitted(parentFormSubmitted: boolean) {
    this._parentFormSubmitted = parentFormSubmitted;
    if (parentFormSubmitted) {
      if (this.form)
        this.form.onSubmit(undefined);
    }
  }
  get parentFormSubmitted(): boolean {
    return this._parentFormSubmitted;
  }
  @Output() onSelectReturn = new EventEmitter<any>();
  @ViewChild('dataForm') form: NgForm;
  constructor(
    private requestService: RequestService, private translate: TranslateService,
    private layoutUtilsService: LayoutUtilsService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.loadData();
  }
  ngOnChanges(changes: SimpleChanges) {
    this.loadData();
  }
  public onSubmit() {
    // do nothing
  }
  private getSelectedItem(val) {
    for (let itm of this.selectData) {
      if (val === itm._id) {
        return itm
      }
    }
    return '';
  }
  public setAttribute(val) {
    let valT = [];
    if (this.apiTarget === 'search') {
      this.onSelectReturn.emit(val);
    } else {
      if (val)
        valT = val.value;
      let returnVal: any[] = [];
      for (let vl of valT) {
        returnVal.push(this.getSelectedItem(vl));
      }
      this.onSelectReturn.emit(returnVal);
    }
  }
  displayFn(data?: any): string | undefined {
    return data ? data.name : undefined;
  }
  public loadData() {

    if (this.dataType == 'tileblock' && this.apiTarget === 'questions') {
      this.loadQuestionsDataSearch();
    } else if (this.dataType === 'tile' && this.apiTarget === 'summary') {
      this.loadDataSearch();
    } else if (this.apiTarget === 'search') {
      this.loadDataSearch();
    } else if (this.apiTarget === 'list/organization') {
      this.loadDataListOrg();
    } else if (this.apiTarget === 'list/application') {
      this.loadDataListApp();
    } else {
      this.loadDataList();
    }
  }
  public loadDataList() {
    if (!this.loading) {
      // Defer loading state update
      queueMicrotask(() => {
        this.loading = true;
        this.errorMessage = '';
        this.cdr.markForCheck();
      });
      this.requestService.getDataL(this.dataType, (data, error) => {
        // Defer all updates to avoid ExpressionChangedAfterItHasBeenCheckedError
        queueMicrotask(() => {
          if (error) {
            this.errorMessage = error;
          }
          if (data) {
            if (this.dataType == 'procedure' && this.apiTarget === 'summary') {
              this.selectData = data.results.filter((item) => {
                return item.type === '0' && item.event === '1';
              });
            } else {
              this.selectData = data.results;
            }
          } else {
            this.selectData = [];
          }
          if (this.hideIfOne && this.selectData.length === 1) {
            this.hideBecauseOne = true;
            this.setAutoOne(this.selectData[0]._id);
          }
          this.filteredData.next(this.selectData);
          this.loading = false;
          this.cdr.markForCheck();
        });
      }, this.canCash);
    }
  }
  public loadDataListApp() {
    if (!this.loading) {
      // Defer loading state update
      queueMicrotask(() => {
        this.loading = true;
        this.errorMessage = '';
        this.cdr.markForCheck();
      });
      this.requestService.getDataL(this.dataType, (data, error) => {
        // Defer all updates to avoid ExpressionChangedAfterItHasBeenCheckedError
        queueMicrotask(() => {
          if (error) {
            this.errorMessage = error;
          }
          if (data) {
            this.selectData = data.results;
          } else {
            this.selectData = [];
          }
          if (this.hideIfOne && this.selectData.length === 1) {
            this.hideBecauseOne = true;
            this.setAutoOne(this.selectData[0]._id);
          }
          this.filteredData.next(this.selectData);
          this.loading = false;
          this.cdr.markForCheck();
        });
      }, false, this.requestService.appId);
    }
  }
  public loadDataListOrg() {
    if (!this.loading) {
      // Defer loading state update
      queueMicrotask(() => {
        this.loading = true;
        this.errorMessage = '';
        this.cdr.markForCheck();
      });
      this.requestService.getDataLByOrg(this.dataType, (data, error) => {
        // Defer all updates to avoid ExpressionChangedAfterItHasBeenCheckedError
        queueMicrotask(() => {
          if (error) {
            this.errorMessage = error;
          }
          if (data) {
            this.selectData = data.results;
          } else {
            this.selectData = [];
          }
          //console.log('this.selectData', this.selectData);
          if (this.hideIfOne && this.selectData.length === 1) {
            this.hideBecauseOne = true;
            this.setAutoOne(this.selectData[0]._id);
          }
          this.filteredData.next(this.selectData);
          this.loading = false;
          this.cdr.markForCheck();
        });
      });
    }
  }
  addOrganizationToFilter(filters) {
    const orgFilter = { 'organizationId': { $eq: this.requestService.orgId } };

    if (!filters || !filters.$and || !Array.isArray(filters.$and)) {
      return {
        $and: [orgFilter]
      };
    }

    // Check if organizationId is already present
    const hasOrgFilter = filters.$and.some(condition => {
      return condition.hasOwnProperty('organizationId');
    });

    if (!hasOrgFilter) {
      filters.$and.push(orgFilter);
    }

    return filters;
  }
  public loadDataSearch() {
    if (!this.loading) {
      // Defer loading state update
      queueMicrotask(() => {
        this.loading = true;
        this.errorMessage = '';
        this.cdr.markForCheck();
      });

      let filterConfiguration = this.addOrganizationToFilter(this.filters);
      this.requestService.getDataListSummary(this.dataType, { page: this.pageNumber, term: this.searchText, perpage: this.pageSize, filter: filterConfiguration }, (data, error) => {
        // Defer all updates to avoid ExpressionChangedAfterItHasBeenCheckedError
        queueMicrotask(() => {
          if (error) {
            this.errorMessage = error;
            this.layoutUtilsService.showNotification(this.translate.instant('An error has occurred. Please try again later.'), this.translate.instant('Dismiss'));
          }
          if (data) {
            if (this.dataType == "tile") {
              this.selectData = data.results?.results;
            } else
              this.selectData = data.results;
          } else {
            this.selectData = [];
          }
          if (this.hideIfOne && this.selectData.length === 1) {
            this.hideBecauseOne = true;
            this.setAutoOne(this.selectData[0]._id);
          }
          this.filteredData.next(this.selectData);
          this.loading = false;
          this.cdr.markForCheck();
        });
      });
    }
  }
  setAutoOne(id) {
    setTimeout(() => {
      this.onSelectReturn.emit([{ _id: id, appId: this.requestService.appId, name: '' }]);
    }, 300);
  }
  termSearch(e): any {
    this.searchText = e.term;
    this.loadDataSearch();
  }
  public loadQuestionsDataSearch() {

    if (!this.loading) {
      // Defer loading state update
      queueMicrotask(() => {
        this.loading = true;
        this.errorMessage = '';
        this.cdr.markForCheck();
      });
      let filterConfiguration = this.filters;
      if (this.RelativeTo !== undefined && this.RelativeTo != '') {
        // console.log("relative to", this.RelativeTo);
        this.requestService.getDataListQuestions(this.dataType, this.RelativeTo, { page: this.pageNumber, term: this.searchText, perpage: this.pageSize, filter: filterConfiguration }, (data, error) => {
          // Defer all updates to avoid ExpressionChangedAfterItHasBeenCheckedError
          queueMicrotask(() => {
            if (error) {
              this.errorMessage = error;
              this.layoutUtilsService.showNotification(error, this.translate.instant('Dismiss'));
            }
            if (data) {
              // console.log(data);
              var i;
              for (i = 0; i < data.results.length; i++) {
                data.results[i].name = data.results[i]['questionText'];
                if (data.results[i].hasOwnProperty('index'))
                  data.results[i]._id = data.results[i]._id + '_' + data.results[i].index;
                delete data.results[i].key1;
              }

              this.selectData = data.results;
            } else {
              this.selectData = [];
            }
            if (this.hideIfOne && this.selectData.length === 1) {
              this.hideBecauseOne = true;
              this.setAutoOne(this.selectData[0]._id);
            }
            this.filteredData.next(this.selectData);
            this.loading = false;
            this.cdr.markForCheck();
          });
        });
      } else {
        // Defer updates when RelativeTo is empty
        queueMicrotask(() => {
          this.loading = false;
          this.selectData = [];
          this.cdr.markForCheck();
        });
      }
    }
  }
}
